import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';

import CommitBetslipButton from 'modules/betslip/betslip-view/commit-betslip-button/index.js';
import withSportPlaceBet from 'modules/betslip/betslip-view/place-bet-button-hoc/index.js';
import withSportSaveBet from 'modules/betslip/betslip-view/save-bet-button-hoc/index.js';
import withSportShareBet from 'modules/betslip/betslip-view/share-bet-button-hoc/index.js';
import PlacementMessages from 'modules/betslip/betslip-view/placement-messages/index.js';

const classUtils = MojitoCore.Base.classUtils;
const PlaceBetButton = withSportPlaceBet(CommitBetslipButton);
const SaveBetButton = withSportSaveBet(CommitBetslipButton);
const ShareBetButton = withSportShareBet(CommitBetslipButton);
const { FlexPane } = MojitoPresentation.Components;
const { COMMIT_BETSLIP_MODE } = MojitoServices.Betslip.types;
const { PLACE_BET, SAVE_BET, SHARE_BET } = COMMIT_BETSLIP_MODE;

const betslipModeMap = {
    [PLACE_BET]: PlaceBetButton,
    [SAVE_BET]: SaveBetButton,
    [SHARE_BET]: ShareBetButton,
};

export default function PlaceBetContent(props) {
    const {
        calculation,
        isSuspended,
        currencyCode,
        commitBetslipMode,
        placeBetButtonDisabled,
        betslipStatus,
        hasBetslipChanges,
        placementErrors,
        class: className,
        mojitoTools: { config, style },
    } = props;

    const ButtonElement = betslipModeMap[commitBetslipMode] || PlaceBetButton;
    const commitBetslipButtonStyles = {
        [PLACE_BET]: style.placeBetslipButton,
        [SAVE_BET]: style.saveBetslipButton,
        [SHARE_BET]: style.shareBetslipButton,
    };

    return (
        <FlexPane
            config={config.placeBetContainer}
            class={classUtils.classNames('ta-PlaceBetContent', className)}
        >
            <FlexPane class={'ta-betslipButtonsContainer'} config={config.betslipButtonsContainer}>
                <ButtonElement
                    config={
                        commitBetslipButtonStyles[commitBetslipMode] || config.commitBetslipButton
                    }
                    calculation={calculation}
                    currencyCode={currencyCode}
                    isSuspended={isSuspended}
                    disabled={placeBetButtonDisabled}
                    hasBetslipChanges={hasBetslipChanges}
                    betslipStatus={betslipStatus}
                    commitBetslipMode={commitBetslipMode}
                />
                <PlacementMessages
                    config={config.placementMessages}
                    placementErrors={placementErrors}
                />
            </FlexPane>
        </FlexPane>
    );
}

PlaceBetContent.getStyle = (config, applicationMode, merge) => {
    const { commitBetslipButton, placeBetslipButton, saveBetslipButton, shareBetslipButton } =
        config;

    return {
        placeBetslipButton: merge(commitBetslipButton, placeBetslipButton),
        saveBetslipButton: merge(commitBetslipButton, saveBetslipButton),
        shareBetslipButton: merge(commitBetslipButton, shareBetslipButton),
    };
};
